import { useUserStats } from "../lib/UserStatsContext";
import { BADGES } from "../lib/userStats";

export default function ProfileActivityTab() {
  const { stats } = useUserStats();

  const earnedBadgeIds = stats?.badges || [];
  const allBadges = Object.values(BADGES);
  const unearnedBadges = allBadges.filter((b) => !earnedBadgeIds.includes(b.id));

  return (
    <>
      {/* Activity Stats */}
      <div className="mb-8">
        <div className="section-label">Activity</div>
        <table className="w-full">
          <tbody>
            <tr className="border-b border-border-light">
              <td className="py-2 text-sm text-muted font-[family-name:--font-ui]">Day streak</td>
              <td className="py-2 text-sm font-semibold text-text font-[family-name:--font-ui] text-right">{stats?.streakDays || 0}</td>
            </tr>
            <tr className="border-b border-border-light">
              <td className="py-2 text-sm text-muted font-[family-name:--font-ui]">Total queries</td>
              <td className="py-2 text-sm font-semibold text-text font-[family-name:--font-ui] text-right">{stats?.totalQueries || 0}</td>
            </tr>
            <tr className="border-b border-border-light">
              <td className="py-2 text-sm text-muted font-[family-name:--font-ui]">Meals analyzed</td>
              <td className="py-2 text-sm font-semibold text-text font-[family-name:--font-ui] text-right">{stats?.totalMealsAnalyzed || 0}</td>
            </tr>
            <tr className="border-b border-border-light">
              <td className="py-2 text-sm text-muted font-[family-name:--font-ui]">Recipes transformed</td>
              <td className="py-2 text-sm font-semibold text-text font-[family-name:--font-ui] text-right">{stats?.totalRecipesAnalyzed || 0}</td>
            </tr>
            <tr className="border-b border-border-light">
              <td className="py-2 text-sm text-muted font-[family-name:--font-ui]">Menus decoded</td>
              <td className="py-2 text-sm font-semibold text-text font-[family-name:--font-ui] text-right">{stats?.totalMenusDecoded || 0}</td>
            </tr>
            <tr>
              <td className="py-2 text-sm text-muted font-[family-name:--font-ui]">Photos analyzed</td>
              <td className="py-2 text-sm font-semibold text-text font-[family-name:--font-ui] text-right">{stats?.totalPhotosAnalyzed || 0}</td>
            </tr>
          </tbody>
        </table>
      </div>

      {/* Achievements */}
      <div className="mb-8">
        <div className="section-label">Achievements ({earnedBadgeIds.length} of {allBadges.length})</div>

        {/* Earned badges */}
        {earnedBadgeIds.length > 0 ? (
          <div className="mb-4">
            {earnedBadgeIds.map((badgeId) => {
              const badge = BADGES[badgeId as keyof typeof BADGES];
              if (!badge) return null;
              return (
                <div key={badge.id} className="py-2 border-b border-border-light last:border-b-0">
                  <div className="text-sm text-text font-[family-name:--font-ui] font-medium">{badge.name}</div>
                  <div className="text-xs text-muted font-[family-name:--font-ui]">{badge.description}</div>
                </div>
              );
            })}
          </div>
        ) : (
          <p className="text-sm text-muted font-[family-name:--font-ui] mb-4">Start using GlycemicAI to earn achievements.</p>
        )}

        {/* Unearned badges */}
        {unearnedBadges.length > 0 && (
          <div>
            <p className="text-xs text-muted font-[family-name:--font-ui] mb-2">Still to unlock</p>
            {unearnedBadges.map((badge) => (
              <div key={badge.id} className="py-1.5">
                <div className="text-sm text-muted font-[family-name:--font-ui]">{badge.name}</div>
              </div>
            ))}
          </div>
        )}
      </div>
    </>
  );
}
